import { render, staticRenderFns } from "./SearchMessagesHistory.vue?vue&type=template&id=ad147552&scoped=true"
import script from "./SearchMessagesHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchMessagesHistory.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SearchMessagesHistory.vue?vue&type=style&index=0&id=ad147552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad147552",
  null
  
)

export default component.exports